import { cn } from "../../../../../utils/classnames";

/**
 * Share of the row the right-hand column takes on desktop: 880px of the
 * 1273px content width in Figma. Several rows on this page use it, so the
 * right-hand columns all line up.
 */
export const WIDE_COLUMN_CLASS = "tw:lg:w-[69.13%]";

/**
 * A short label pinned to the left with the body copy in a wider column on the
 * right. On mobile the label simply sits above the copy.
 *
 * The label is capped at 180px so longer ones break onto two lines the way the
 * design does ("Airport & Shinkansen / Pick-up").
 */
export const LabeledSplit = ({ label, children, className }) => (
  <div
    className={cn(
      "tw:flex tw:flex-col tw:lg:flex-row tw:lg:justify-between tw:gap-4 tw:lg:gap-8",
      className
    )}
  >
    <div className="tw:lg:max-w-[180px] tw:font-hanken-grotesk tw:font-semibold tw:text-[18px] tw:leading-[25px] tw:text-[#282828]">
      {label}
    </div>
    <div className={cn("tw:min-w-0 tw:lg:shrink-0", WIDE_COLUMN_CLASS)}>
      {children}
    </div>
  </div>
);
